var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1386_49696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87499 11.6921V10.2078C7.87499 10.1348 7.85025 10.0736 7.80077 10.0242C7.75129 9.97469 7.6927 9.94995 7.62499 9.94995H6.12499C6.05728 9.94995 5.99868 9.97469 5.94921 10.0242C5.89973 10.0736 5.87499 10.1348 5.87499 10.2078V11.6921C5.87499 11.7651 5.89973 11.8263 5.94921 11.8757C5.99868 11.9252 6.05728 11.95 6.12499 11.95H7.62499C7.6927 11.95 7.75129 11.9252 7.80077 11.8757C7.85025 11.8263 7.87499 11.7651 7.87499 11.6921ZM7.85936 8.77026L7.99999 5.18433C7.99999 5.12183 7.97394 5.07235 7.92186 5.03589C7.85415 4.9786 7.79165 4.94995 7.73436 4.94995H6.01561C5.95832 4.94995 5.89582 4.9786 5.82811 5.03589C5.77603 5.07235 5.74999 5.12703 5.74999 5.19995L5.8828 8.77026C5.8828 8.82235 5.90884 8.86532 5.96092 8.89917C6.01301 8.93302 6.07551 8.94995 6.14842 8.94995H7.59374C7.66665 8.94995 7.72785 8.93302 7.77733 8.89917C7.82681 8.86532 7.85415 8.82235 7.85936 8.77026ZM7.74999 1.47339L13.75 12.4734C13.9323 12.8015 13.9271 13.1296 13.7344 13.4578C13.6458 13.6088 13.5247 13.7286 13.3711 13.8171C13.2174 13.9057 13.0521 13.95 12.875 13.95H0.874986C0.697903 13.95 0.532538 13.9057 0.378893 13.8171C0.225247 13.7286 0.104153 13.6088 0.0156114 13.4578C-0.177097 13.1296 -0.182305 12.8015 -1.35601e-05 12.4734L5.99999 1.47339C6.08853 1.31193 6.21092 1.18433 6.36717 1.09058C6.52342 0.996826 6.6927 0.949951 6.87499 0.949951C7.05728 0.949951 7.22655 0.996826 7.3828 1.09058C7.53905 1.18433 7.66145 1.31193 7.74999 1.47339Z",
    fill: "#CC6600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1386_49696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8,
    height: 14,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 14.95)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.5f592f6b936ce1ecf1580c8f7872e633.svg";
export { ForwardRef as ReactComponent };